import { createContext } from 'react';
let SelectedTeamContext = createContext(null);
export default SelectedTeamContext;